import { render, staticRenderFns } from "./ConsumoQtdPorSubItem.vue?vue&type=template&id=37f93409"
import script from "./ConsumoQtdPorSubItem.vue?vue&type=script&lang=js"
export * from "./ConsumoQtdPorSubItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports